import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Copy, ExternalLink, Trash2, Share2 } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function SharedCards() {
  const [cards, setCards] = useState(null);

  const load = () => api.get("/share/cards").then((r) => setCards(r.data.cards));
  useEffect(() => {
    load();
  }, []);

  const copy = (id) => {
    const url = `${window.location.origin}/share/${id}`;
    navigator.clipboard?.writeText(url).then(
      () => toast.success("Public link copied", { description: url }),
      () => toast.info(url)
    );
  };

  const revoke = async (id) => {
    await api.delete(`/share/cards/${id}`);
    toast.success("Card revoked — the public link is now dead");
    load();
  };

  return (
    <div className="space-y-6 fade-up">
      <div>
        <div className="overline-label mb-2">Public research cards</div>
        <h1 className="font-heading font-black tracking-tighter text-4xl sm:text-5xl text-white">My shared cards</h1>
      </div>

      <div className="widget" data-testid="shared-cards-list">
        {!cards ? (
          <p className="p-6 text-sm text-muted-foreground">Loading…</p>
        ) : cards.length === 0 ? (
          <div className="p-10 flex flex-col items-center gap-3 text-muted-foreground">
            <Share2 className="w-7 h-7 opacity-50" />
            <p className="text-sm" data-testid="no-shared-cards">
              No shared cards yet. Generate an AI summary on any <Link to="/scanner" className="text-primary hover:underline">stock page</Link> and hit "Share research card".
            </p>
          </div>
        ) : (
          cards.map((c) => (
            <div key={c.id} data-testid={`shared-card-row-${c.id}`}
              className="flex items-center gap-4 px-5 py-4 border-b border-border/50 last:border-0 even:bg-white/[0.02]">
              <div className="flex-1 min-w-0">
                <div className="font-mono font-medium text-primary">{c.ticker}</div>
                <div className="text-xs text-muted-foreground truncate">
                  {c.name} · shared {new Date(c.created_at).toLocaleDateString()}
                </div>
              </div>
              <button onClick={() => copy(c.id)} data-testid={`copy-link-${c.id}`}
                className="p-2 text-muted-foreground hover:text-white hover:bg-white/5 rounded-sm transition-colors duration-150" title="Copy public link">
                <Copy className="w-4 h-4" />
              </button>
              <a href={`/share/${c.id}`} target="_blank" rel="noopener noreferrer" data-testid={`open-card-${c.id}`}
                className="p-2 text-muted-foreground hover:text-white hover:bg-white/5 rounded-sm transition-colors duration-150" title="Open public page">
                <ExternalLink className="w-4 h-4" />
              </a>
              <button onClick={() => revoke(c.id)} data-testid={`revoke-card-${c.id}`}
                className="p-2 text-muted-foreground hover:text-loss hover:bg-white/5 rounded-sm transition-colors duration-150" title="Revoke">
                <Trash2 className="w-4 h-4" />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
